import { embedParentOriginMatchesMessage } from '../embed_parent_origin'

import { normalizeHostConsent } from './consent_normalize'

/** Parent → iframe embed consent update (CalendlyConsentUpdateV1). */
const CONSENT_UPDATE_MESSAGE_EVENT = 'calendly.consent.update.v1'

let lastConsentUpdate = null
const subscribers = new Set()

const notifySubscriber = (callback, payload) => {
  try {
    callback(payload)
  } catch {
    /* noop */
  }
}

const dispatchConsentUpdateToSubscribers = (payload) => {
  lastConsentUpdate = payload
  subscribers.forEach((cb) => {
    notifySubscriber(cb, payload)
  })
}

/**
 * Handles a message from the parent window to update the embed's consent state.
 * Messages are only applied when the URL's `embed_domain` matches the postMessage origin.
 * @param {MessageEvent} event
 */
export const handleConsentUpdateMessage = (event) => {
  if (!event?.data || event.data.type !== CONSENT_UPDATE_MESSAGE_EVENT) return
  if (!embedParentOriginMatchesMessage(window.location.search, event.origin)) return

  const normalized = normalizeHostConsent(event.data.consent)
  if (!normalized) return
  dispatchConsentUpdateToSubscribers(normalized)
}

/**
 * Subscribe to consent updates. If a consent update has already been received, the subscriber
 * is invoked synchronously with the last value so late mounters can read the current state.
 * @param {(payload: object) => void} callback
 * @returns {() => void} unsubscribe
 */
export const subscribeConsentUpdate = (callback) => {
  subscribers.add(callback)
  if (lastConsentUpdate) notifySubscriber(callback, lastConsentUpdate)
  return () => subscribers.delete(callback)
}
